import React from 'react';
import styles from './styles';
import logoHouseWhite from '@assets/ta-house-white.svg';
import logoText from '@assets/logo-text.svg';

export const SplashScreen = () => {
  const classes = styles();
  (window as any).usabilla_live("setButtonZIndex","1")
  return (
    <div className={classes.splashScreen}>
      <div className={classes.splashScreenElement}>
        <span className={classes.splashScreenLogo}>
          <img src={logoHouseWhite} alt="" />
        </span>
        <span className={classes.splashScreenLogoText}>
          <img src={logoText} alt="" />
        </span>
      </div>
    </div>
  );
};

export default SplashScreen;
